import { render, staticRenderFns } from "./AddRecordMail.vue?vue&type=template&id=05ad6066&scoped=true"
import script from "./AddRecordMail.vue?vue&type=script&lang=js"
export * from "./AddRecordMail.vue?vue&type=script&lang=js"
import style0 from "./AddRecordMail.vue?vue&type=style&index=0&id=05ad6066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ad6066",
  null
  
)

export default component.exports